var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DBE4F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 29.666C45.8334 31.3193 44.4867 32.666 42.8334 32.666H38.1667C37.34 32.666 36.5934 32.3327 36.0467 31.786C35.5 31.2393 35.1667 30.4927 35.1667 29.666C35.1667 28.0127 36.5134 26.666 38.1667 26.666H42.8334C43.66 26.666 44.4067 26.9993 44.9534 27.546C45.5 28.0927 45.8334 28.8393 45.8334 29.666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6066 30.7056C49.2983 30.4526 48.9518 30.2501 48.58 30.1056C48.1933 29.959 47.8066 30.2656 47.7266 30.6656C47.2733 32.9456 45.26 34.6656 42.8333 34.6656H38.1666C36.8333 34.6656 35.58 34.1456 34.6333 33.199C33.9408 32.5119 33.4675 31.635 33.2733 30.679C33.1933 30.279 32.7933 29.959 32.4066 30.119C30.86 30.7456 29.8333 32.159 29.8333 34.999V47.999C29.8333 51.999 32.22 53.3323 35.1666 53.3323H45.8333C48.78 53.3323 51.1666 51.999 51.1666 47.999V34.999C51.1666 32.8256 50.5666 31.4923 49.6066 30.7056ZM35.1666 40.3323H40.5C41.0466 40.3323 41.5 40.7856 41.5 41.3323C41.5 41.879 41.0466 42.3323 40.5 42.3323H35.1666C34.62 42.3323 34.1666 41.879 34.1666 41.3323C34.1666 40.7856 34.62 40.3323 35.1666 40.3323ZM45.8333 47.6656H35.1666C34.62 47.6656 34.1666 47.2123 34.1666 46.6656C34.1666 46.119 34.62 45.6656 35.1666 45.6656H45.8333C46.38 45.6656 46.8333 46.119 46.8333 46.6656C46.8333 47.2123 46.38 47.6656 45.8333 47.6656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyShipment);
export default __webpack_public_path__ + "static/media/empty_shipment.f49af27e22dededf5635cd2fd35ab641.svg";
export { ForwardRef as ReactComponent };